import * as types from './types'

export const actions = {
	getMismatchAction: (payload) => ({
		type: types.GET_MISMATCH_ACTION,
	}),

	getMismatchActionDone: (payload) => ({
		type: types.GET_MISMATCH_ACTION_DONE,
		payload,
	}),

	getMismatchActionFail: (payload) => ({
		type: types.GET_MISMATCH_ACTION_FAIL,
	}),


	getMismatchXslAction: (payload) => ({
		type: types.GET_MISMATCH_XSL_ACTION,
	}),

	getMismatchXslActionDone: (payload) => ({
		type: types.GET_MISMATCH_XSL_ACTION_DONE,
		payload,
	}),

	getMismatchXslActionFail: (payload) => ({
		type: types.GET_MISMATCH_XSL_ACTION_FAIL,
	}),
}
